import storage from '../utils/storage';
import lazyChannel from '@/router/lazyChannel';
import lazyDistributor from '@/router/lazyDistributor';

export function getRouter() {
   let arr = [];
   if (storage.get('user') != null) {
     const proxyModelId = storage.get('user').proxyModelId;
     const distributorRouter = lazyDistributor.distributorRouter;
     const channelRouter = lazyChannel.channelRouter;
     arr = proxyModelId == '31' ? channelRouter : distributorRouter;
     return arr;
   } else {
     return arr;
   }
}

let _map = new Map();

export function getRouterMap() {
  if (_map.size == 0) {
    // 非递归遍历树形
    let stack = [{path: '/', children: [lazyChannel.channelRouter[0], lazyDistributor.distributorRouter[0]]}];
    while (stack.length) {
      let router = stack.pop();
      _map.set(router.path, router);
      if (router.children) {
        for (let i = 0; i < router.children.length; i++) {
          stack.push(router.children[i]);
        }
      }
    }
  }
  return _map;
}





// WEBPACK FOOTER //
// ./src/router/lazyRouter.js